import request from '../utils/request'

export function getMerchantAuthAudits(params) {
  return request({ url: '/api/admin/audits/merchant-auth', method: 'get', params })
}

export function getMerchantAuthAuditDetail(id) {
  return request({ url: `/api/admin/audits/merchant-auth/${id}`, method: 'get' })
}

export function approveMerchantAuth(id, data) {
  return request({ url: `/api/admin/audits/merchant-auth/${id}/approve`, method: 'post', data })
}

export function rejectMerchantAuth(id, data) {
  return request({ url: `/api/admin/audits/merchant-auth/${id}/reject`, method: 'post', data })
}

export function getArtistProfileAudits(params) {
  return request({ url: '/api/admin/audits/artist-profile', method: 'get', params })
}

export function getArtistProfileAuditDetail(id) {
  return request({ url: `/api/admin/audits/artist-profile/${id}`, method: 'get' })
}

export function approveArtistProfile(id, data) {
  return request({ url: `/api/admin/audits/artist-profile/${id}/approve`, method: 'post', data })
}

export function rejectArtistProfile(id, data) {
  return request({ url: `/api/admin/audits/artist-profile/${id}/reject`, method: 'post', data })
}

export function supplementArtistProfile(id, data) {
  return request({ url: `/api/admin/audits/artist-profile/${id}/supplement`, method: 'post', data })
}

export function getArtistStarProfileAudits(params) {
  return request({ url: '/api/admin/audits/artist-star-profile', method: 'get', params })
}

export function getArtistStarProfileAuditDetail(id) {
  return request({ url: `/api/admin/audits/artist-star-profile/${id}`, method: 'get' })
}

export function approveArtistStarProfile(id, data) {
  return request({ url: `/api/admin/audits/artist-star-profile/${id}/approve`, method: 'post', data })
}

export function rejectArtistStarProfile(id, data) {
  return request({ url: `/api/admin/audits/artist-star-profile/${id}/reject`, method: 'post', data })
}

export function supplementArtistStarProfile(id, data) {
  return request({ url: `/api/admin/audits/artist-star-profile/${id}/supplement`, method: 'post', data })
}

export function getArtistTalentVideoAudits(params) {
  return request({ url: '/api/admin/audits/artist-talent-video', method: 'get', params })
}

export function getArtistTalentVideoAuditDetail(id) {
  return request({ url: `/api/admin/audits/artist-talent-video/${id}`, method: 'get' })
}

export function approveArtistTalentVideo(id, data) {
  return request({ url: `/api/admin/audits/artist-talent-video/${id}/approve`, method: 'post', data })
}

export function rejectArtistTalentVideo(id, data) {
  return request({ url: `/api/admin/audits/artist-talent-video/${id}/reject`, method: 'post', data })
}

export function getArtistRealnameAudits(params) {
  return request({ url: '/api/admin/audits/artist-realname', method: 'get', params })
}

export function getArtistRealnameAuditDetail(id) {
  return request({ url: `/api/admin/audits/artist-realname/${id}`, method: 'get' })
}

export function approveArtistRealname(id, data) {
  return request({ url: `/api/admin/audits/artist-realname/${id}/approve`, method: 'post', data })
}

export function rejectArtistRealname(id, data) {
  return request({ url: `/api/admin/audits/artist-realname/${id}/reject`, method: 'post', data })
}

export function getCastingNoticeAudits(params) {
  return request({ url: '/api/admin/audits/casting-notice', method: 'get', params })
}

export function getCastingNoticeAuditDetail(id) {
  return request({ url: `/api/admin/audits/casting-notice/${id}`, method: 'get' })
}

export function approveCastingNotice(id, data) {
  return request({ url: `/api/admin/audits/casting-notice/${id}/approve`, method: 'post', data })
}

export function rejectCastingNotice(id, data) {
  return request({ url: `/api/admin/audits/casting-notice/${id}/reject`, method: 'post', data })
}

export function offShelfCastingNotice(id, data) {
  return request({ url: `/api/admin/audits/casting-notice/${id}/off-shelf`, method: 'post', data })
}

export function onShelfCastingNotice(id, data) {
  return request({ url: `/api/admin/audits/casting-notice/${id}/on-shelf`, method: 'post', data })
}

export function banCastingNotice(id, data) {
  return request({ url: `/api/admin/audits/casting-notice/${id}/ban`, method: 'post', data })
}

export function unbanCastingNotice(id, data) {
  return request({ url: `/api/admin/audits/casting-notice/${id}/unban`, method: 'post', data })
}
